import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'csn-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent {
  googleLoginUrl = environment.apiUrl + '/auth/google';

  email: string = '';
  password: string = '';
  errorMessage: string | null = null;

  @ViewChild('emailInput') emailInputRef?: ElementRef<HTMLInputElement>;
  @ViewChild('passwordInput') passwordInputRef?: ElementRef<HTMLInputElement>;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
  }

  async signInClicked() {
    // Password managers and browser autofill write directly to the DOM without
    // firing Angular's `input` event, leaving ngModel-bound properties empty.
    // Read nativeElement.value as fallback to capture whatever was filled.
    const email = this.email || this.emailInputRef?.nativeElement.value || '';
    const password = this.password || this.passwordInputRef?.nativeElement.value || '';

    this.errorMessage = null;
    try {
      await this.authService.basic(email, password);
      this.authService.setAuthenticated();
      await this.router.navigateByUrl('/courses');
    } catch (e: any) {
      if (this.authService.isAuthenticated()) {
        // Auth succeeded but the router threw internally (e.g. guard exception).
        // The httpOnly cookie is already set — a refresh will land the user correctly.
        this.errorMessage = 'You are signed in. Please refresh the page to continue.';
      } else {
        this.errorMessage = e?.error?.message || e?.message || 'Sign-in failed. Please check your credentials and try again.';
      }
      this.cdr.markForCheck();
    }
  }
}
